/**
 * SEO helper — sets document title, meta description, OpenGraph tags,
 * JSON-LD product schema, and canonical URL per page.
 *
 * Usage:
 *   <SEO title="..." description="..." image="..." type="product" price={...} />
 */
import { Helmet } from "react-helmet-async";

export default function SEO({
    title,
    description,
    image,
    type = "website",
    price,
    priceInr,
    availability = "in_stock",
    canonical,
    jsonLd,
}) {
    const siteName = "X-Plosiv";
    const t = title ? `${title} — ${siteName}` : `${siteName} — Events, experiences and promotions.`;
    const url = canonical || (typeof window !== "undefined" ? window.location.href : "https://x-plosiv.com/");
    return (
        <Helmet>
            <title>{t}</title>
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={url} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:type" content={type === "product" ? "product" : "website"} />
            <meta property="og:title" content={t} />
            {description && <meta property="og:description" content={description} />}
            {image && <meta property="og:image" content={image} />}
            <meta property="og:url" content={url} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={t} />
            {description && <meta name="twitter:description" content={description} />}
            {image && <meta name="twitter:image" content={image} />}
            {price != null && (
                <>
                    <meta property="product:price:amount" content={priceInr ?? price} />
                    <meta property="product:price:currency" content="INR" />
                    <meta property="product:availability" content={availability} />
                </>
            )}
            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    );
}
